import _ from "underscore"
import TemplateView from "../../TemplateView"
import UserTime from "../../user_time"
import messageResource from "../../messageResource"

export default class ProgressBar extends TemplateView {
    constructor($containerEl) {
        super($containerEl);
    }

    templateHtml() {
        return "<div class='estimateBar'><div class='spentBar'/></div>" +
               "<div class='spent'><%=spent%>: <span class='spentValue'/>" +
               "</div>" +
               "<div class='ofEstimated'><%=of%> <span class='estimatedValue'/></div>";
    }

    messageKeys() {
        return {
            spent: "task.edit_panel.spent",
            of: "common.of"
        }
    }

    afterRender() {
        this.spentTime = null;
        this.estimatedTime = null;
        this.$spent = this.$containerEl.find('.spent');
        this.$spentValue = this.find('.spentValue');
        this.$ofEsimated = this.$containerEl.find('.ofEstimated');
        this.$estimatedValue = this.find('.estimatedValue');
        this.$percent = this.find('.percent');
        this.$exceeded = this.find('.exceeded');
        this.$percentValue = this.find('.percentValue');
        this.$exceededValue = this.find('.exceededValue');
        this.$spentBar = this.find('.spentBar');
        this.$estimateBar = this.$containerEl.find('.estimateBar');
    }

    update() {
        if (_.isNull(this.spentTime))
            return;
        var estimated = _.isNumber(this.estimatedTime);
        var exceeded = estimated && (this.spentTime > this.estimatedTime);
        this.$containerEl.toggleClass('withEstimate', estimated);
        this.$containerEl.toggleClass('exceeded', exceeded);
        var spentValString = UserTime.formatTimeWithDigitSeparator(this.spentTime);
        if (estimated) {
            this.$estimatedValue.text(UserTime.formatTimeWithDigitSeparator(this.estimatedTime));
            var ratio = this._calcRatio();
            var barWidth = this.$estimateBar.width();
            this.$spentBar.width(((ratio <= 1) ? ratio : 1) * barWidth);
            if (this.spentTime > 0) {
                spentValString += ' (' + (this.estimatedTime > 0 ? (Math.round(ratio * 100) + '%') : '');
            }
            if (exceeded) {
                spentValString += (this.estimatedTime > 0) ? ', ' : '';
                spentValString += messageResource.getMessage("task.edit_panel.exceeded") + ' ' +
                                  UserTime.formatTimeWithDigitSeparator(this.spentTime - this.estimatedTime);
            }
            if (this.spentTime > 0) {
                spentValString += ')';
            }
        }
        this.$spentValue.text(spentValString);
    }

    setEstimatedTime(estimatedTime) {
        this.estimatedTime = estimatedTime;
    }

    setSpentTime(spentTime) {
        this.spentTime = spentTime;
    }

    _calcRatio() {
        return this.spentTime / this.estimatedTime;
    }
}


// WEBPACK FOOTER //
// ./web/js/controls/task/ProgressBar.js